import type { Step } from "../script";

export const scanComplete: Step[] = [
  {
    kind: "panel",
    view: "intelligence",
    focus: { kind: "portfolio" },
    pauseAfter: 800,
  },
  {
    kind: "msg",
    id: "msg-01",
    tokens: "overnight scan is in. three things worth walking through.",
    pauseAfter: 1300,
  },
];
